import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Link } from '@mui/material';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Показываем баннер через 2 секунды после загрузки
      const timer = setTimeout(() => {
        setVisible(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: 'rgba(0, 0, 0, 0.85)',
        color: 'white',
        p: { xs: 2, sm: 3 },
        zIndex: 9999,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2,
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="body2" sx={{ maxWidth: { xs: '100%', sm: '70%' } }}>
        🍪 Мы используем локальное хранилище браузера (localStorage) для хранения 
        токенов авторизации и настроек. Продолжая использовать сайт, вы соглашаетесь 
        на обработку персональных данных.{' '}
        <Link href="/privacy-policy" target="_blank" sx={{ color: '#64b5f6' }}>
          Подробнее
        </Link>
      </Typography>
      
      <Button
        variant="contained"
        onClick={handleAccept}
        sx={{
          bgcolor: '#3390ec',
          color: 'white',
          fontWeight: 'bold',
          whiteSpace: 'nowrap',
          '&:hover': {
            bgcolor: '#2a7bc8',
          },
        }}
      >
        Принять
      </Button>
    </Box>
  );
};

export default CookieBanner;
